import React, { useContext, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAboutData, uploadAboutFile, deleteAboutFile, downloadAboutFile } from '../../../actions/settings/about'
import styles from '../styles.module.scss'
import { Input, Quill } from '../../../components/ModalInputs'
import { SettingsContext } from '../../../utils/context'
import logoSmall from '../../../assets/images/layout/logoSmall.png'
import { createNotification } from '../../../components/Notifications/Notifications'


export default function About() {

  const dispatch = useDispatch()
  const { about } = useSelector(state => state.settings)
  const { form } = useContext(SettingsContext)

  const { values, handleChange, handleBlur, setFieldValue } = form

  const certificateInputRef = useRef(null)
  const licenseInputRef = useRef(null)

  useEffect(() => {
    !about && dispatch(getAboutData())
  }, [])

  // Проверка на null, NULL, undefined, пустую строку
  const isFileExists = (fileName) => {
    return fileName && fileName !== 'null' && fileName !== 'NULL' && fileName.trim() !== ''
  }

  const handleFileUpload = (e, fieldName) => {
    const file = e.target.files[0]
    if (file) {
      dispatch(uploadAboutFile(file, fieldName))
      setFieldValue(fieldName, file.name)
    }
    e.target.value = ''
  }

  const handleFileDelete = (fieldName) => {
    const fileName = values[fieldName]
    if (isFileExists(fileName)) {
      dispatch(deleteAboutFile(fieldName, fileName))
      setFieldValue(fieldName, '')
    } else {
      createNotification('warning', 'Файл не выбран')
    }
  }

  const handleFileDownload = (fieldName) => {
    const fileName = values[fieldName]
    if (isFileExists(fileName)) {
      dispatch(downloadAboutFile(fieldName, fileName))
    } else {
      createNotification('warning', 'Файл не выбран')
    }
  }

  // Получить отображаемое имя файла (с учётом null/NULL)
  const getDisplayFileName = (fileName) => {
    return isFileExists(fileName) ? fileName : ''
  }

  return (
    <div className={styles.inputsWrapper} style={{ flexDirection: 'column' }}>
      <Input
        label='Дата образования'
        name='Foundation_date'
        type='date'
        style={{ width: '150px' }}
        value={values.Foundation_date}
        onChange={handleChange}
      />

      <Input
        label='Основание'
        name='Foundation_reason'
        style={{ width: '650px' }}
        value={values.Foundation_reason}
        onChange={handleChange}
      />

      <Quill
        label='Описание'
        value={values.AboutOrg}
        onChange={val => setFieldValue('AboutOrg', val)}
        name='AboutOrg'
      />
      <div className={styles.filesWrapper}>
        <div className={styles.filesSection}>
          <p className={styles.filesTitle}>Файлы:</p>

          <div className={styles.fileBlock}>
            <p className={styles.fileLabel}>
              Лицензия на право осуществления образовательной деятельности
            </p>
            <div className={styles.fileRow}>
              <div className={styles.fileButtons}>
                <input
                  type="file"
                  ref={licenseInputRef}
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileUpload(e, 'LicenseForEducationalActivities')}
                />
                <button
                  type="button"
                  className={styles.addBtn}
                  title="Добавить"
                  onClick={() => licenseInputRef.current.click()}
                >+</button>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  title="Удалить"
                  onClick={() => handleFileDelete('LicenseForEducationalActivities')}
                >×</button>
                <button
                  type="button"
                  className={styles.viewBtn}
                  title="Скачать"
                  onClick={() => handleFileDownload('LicenseForEducationalActivities')}
                >↓</button>
              </div>
              <span className={styles.fileName}>
                {getDisplayFileName(values.LicenseForEducationalActivities)}
              </span>
            </div>
          </div>

          <div className={styles.fileBlock}>
            <p className={styles.fileLabel}>
              Свидетельство о государственной аккредитации образовательной организации
            </p>
            <div className={styles.fileRow}>
              <div className={styles.fileButtons}>
                <input
                  type="file"
                  ref={certificateInputRef}
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileUpload(e, 'CertificateStateAccreditationEeducationalOrganization')}
                />
                <button
                  type="button"
                  className={styles.addBtn}
                  title="Добавить"
                  onClick={() => certificateInputRef.current.click()}
                >+</button>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  title="Удалить"
                  onClick={() => handleFileDelete('CertificateStateAccreditationEeducationalOrganization')}
                >×</button>
                <button
                  type="button"
                  className={styles.viewBtn}
                  title="Скачать"
                  onClick={() => handleFileDownload('CertificateStateAccreditationEeducationalOrganization')}
                >↓</button>
              </div>
              <span className={styles.fileName}>
                {getDisplayFileName(values.CertificateStateAccreditationEeducationalOrganization)}
              </span>
            </div>
          </div>
        </div>

        <div className={styles.logoSection}>
          <p className={styles.logoTitle}>Логотип для сайта</p>
          <div className={styles.logoImage}>
            <img src={logoSmall} alt='Логотип' style={{ width: '120px', height: '120px', objectFit: 'contain' }} />
          </div>
        </div>
      </div>
    </div>
  )
}
